import { createStore } from 'effector';

export interface AppointmentsStateInterface {}
const defaultState: AppointmentsStateInterface = {};

const $store = createStore(defaultState);

export default $store;
